import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {CustomToastService} from "../utils/custom-toast.service";
import {AuthService} from "../services/auth/auth.service";
import {TranslateService} from "@ngx-translate/core";
import {ConfigService} from "../config/services/config.service";
import {JsonHelper} from "../utils/json-helper";


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  authService;
  configService;

  constructor(
    private readonly injector: Injector
  ) {
    this.authService = this.injector.get(AuthService);
    this.configService = this.injector.get(ConfigService);
  }

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				console.error('Error caught from http interceptor', error);

        // check if error.error is valid json if not use JSON.parse.
        let parsedError = JsonHelper.parseToJson(error.error);

        const reason = parsedError?.reason || 'unknown';

        let toastMessage;
        let timeoutValue;
        let translateService = this.injector.get(TranslateService);

        if (this.configService.featureConfig.kommunalportalAuth) {
          toastMessage = translateService.instant('AUTHENTICATION.SESSION.TIMEOUT_KOMMUNALPORTAL');
          timeoutValue = 5000;
        } else if (this.configService.featureConfig.jwtAuth) {
          toastMessage = translateService.instant('AUTHENTICATION.SESSION.TIMEOUT_JWT');
          timeoutValue = 2000;
        } else {
          toastMessage = translateService.instant('AUTHENTICATION.SESSION.TIMEOUT_GENERIC');
          timeoutValue = 2000;
        }
        const customToast = this.injector.get(CustomToastService)

        const translationKey = 'EXCEPTION.' + reason;
        const translatedMessage = translateService.instant(translationKey, {'errorCode': reason});
        if (translatedMessage !== translationKey) {
          customToast.showError(translatedMessage);
          return throwError(() => error);
        } else {
          console.log('Global intercept, no translation found for key: ' + translationKey + '. Error Code: ' + reason);
        }

				switch (error.status) {
          case 401:
            // most of the time there are multiple 401 errors on the same time. Call isDuplicate() to prevent multiple toasts to be shown.
            if (!customToast.isDuplicate(toastMessage, 'error') && !request.url.includes('auth/token')) {
              customToast.showError(toastMessage);
              setTimeout(() => {
                this.authService.logout();
              }, timeoutValue)
            }
						break;
          case 0: // cross-origin block or other client-side abort
            // most of the time there are multiple 401 errors on the same time. Call isDuplicate() to prevent multiple toasts to be shown.
            if (!customToast.isDuplicate(toastMessage, 'error')) {
              customToast.showError(toastMessage);
              setTimeout(() => {
                this.authService.logout();
              }, timeoutValue)
            }
            break;
          case 400:
            const errorMessages = error.error;
            const hasFileValidationError = Array.isArray(errorMessages) && errorMessages.some(err => err.error && err.error.includes("FILEVALIDATION"));
            if (hasFileValidationError) {
              try {
                let toastMessage : string[] = [];
                const customToast = this.injector.get(CustomToastService);
                const translate = this.injector.get(TranslateService);
                errorMessages.forEach(err=> {
                    toastMessage.push(translate.instant("FILEVALIDATION." + err.error));
                    const details = err.details
                    if(details){
                      let collectedDetails : string[] = [];
                      if(Array.isArray(details)) {
                        details.forEach(detail => {
                          if(detail.need)
                            collectedDetails.push(detail.need);
                        })
                      } else {
                        if(details.need)
                          collectedDetails.push(details.need);
                      }
                      toastMessage.push(collectedDetails.join(", "));
                    }
                  }
                )
                customToast.showError(toastMessage.join(" "));
              } catch {
                console.log(errorMessages);
              }
              return throwError(() => error);
            }
            return throwError(() => error);
					default:
						break;
				}

        return throwError(() => error);
			}),
			finalize(() => {})
		);
	}
}
